import React from 'react';
import { Calculator } from 'lucide-react';
import { BlocEmail } from './SuiviPrivatisationNotificationBlocks';
import { GroupeNotifications } from '../ui/LigneNotification';

/**
 * Section « Demande de devis » de l'onglet Notifications (2026-09-20).
 *
 * Deux courriels partent quand un visiteur va au bout du simulateur de votre site : l'alerte qui vous
 * prévient qu'une demande attend d'être étudiée, et l'accusé de réception qui rassure le visiteur — il
 * vient de confier ses photos et ses coordonnées. Aucun des deux n'est écrit en dur : tout se règle ici.
 */

const JETONS_COMMUNS = [
    { token: '{{entreprise}}', label: 'Votre établissement' },
    { token: '{{client_nom}}', label: 'Nom du client (ou sa société)' },
    { token: '{{prenom}}', label: 'Prénom du client' },
    { token: '{{nom}}', label: 'Nom du client' },
    { token: '{{prestations}}', label: 'Ce qu\'il a sélectionné, avec les quantités' },
    { token: '{{montant}}', label: 'Estimation qui lui a été affichée' },
    { token: '{{formule}}', label: 'Formule retenue (ou « — »)' },
    { token: '{{logo}}', label: 'Votre logo' },
];

const JETONS_ALERTE = [...JETONS_COMMUNS,
    { token: '{{photos}}', label: 'Nombre de photos jointes' },
    { token: '{{telephone}}', label: 'Son téléphone' },
    { token: '{{email}}', label: 'Son email' },
    { token: '{{adresse}}', label: "Adresse de l'intervention" },
    { token: '{{message}}', label: 'Son message' },
];

export interface DemandeDevisNotifications {
    notify_devis_request_new: boolean;
    devis_request_new_subject: string;
    devis_request_new_body: string;
    notify_devis_request_ack: boolean;
    devis_request_ack_subject: string;
    devis_request_ack_body: string;
}

export const DEMANDE_DEVIS_NOTIFS_VIDES: DemandeDevisNotifications = {
    notify_devis_request_new: true, devis_request_new_subject: '', devis_request_new_body: '',
    notify_devis_request_ack: true, devis_request_ack_subject: '', devis_request_ack_body: '',
};

export function DemandeDevisNotificationBlocks({ valeurs, onChange }: {
    valeurs: DemandeDevisNotifications;
    onChange: (patch: Partial<DemandeDevisNotifications>) => void;
}) {
    return (
        <GroupeNotifications titre="Demande de devis (simulateur)" icone={<Calculator size={12} />}>
            <BlocEmail
                titre="Nouvelle demande de devis (pour vous)"
                description="Part sur l'adresse de votre établissement à chaque demande. Les photos restent dans le dossier, jamais en pièce jointe."
                bascule={{ checked: valeurs.notify_devis_request_new, onChange: (v) => onChange({ notify_devis_request_new: v }) }}
                sujet={valeurs.devis_request_new_subject} setSujet={(v) => onChange({ devis_request_new_subject: v })}
                corps={valeurs.devis_request_new_body} setCorps={(v) => onChange({ devis_request_new_body: v })}
                jetons={JETONS_ALERTE} />
            <BlocEmail
                titre="Accusé de réception au client"
                description="Dites-y que le montant simulé reste indicatif : c'est votre devis qui fait foi. Sans cet email, le visiteur n'a aucune trace de sa demande."
                bascule={{ checked: valeurs.notify_devis_request_ack, onChange: (v) => onChange({ notify_devis_request_ack: v }) }}
                sujet={valeurs.devis_request_ack_subject} setSujet={(v) => onChange({ devis_request_ack_subject: v })}
                corps={valeurs.devis_request_ack_body} setCorps={(v) => onChange({ devis_request_ack_body: v })}
                jetons={JETONS_COMMUNS} />
        </GroupeNotifications>
    );
}
